import { useQuery } from '@tanstack/react-query';

import { searchSentEmails } from '~/services/SailthruService';

export const INFINITE_ONBOARDING_NOTIFICATION_TYPE = 'infinite_onboarding';

export const infiniteOnboardingEmailQueryKeys = {
  all: ['infinite-onboarding-emails'] as const,
  byEmail: (email: string) => [...infiniteOnboardingEmailQueryKeys.all, email] as const,
};

interface UseInfiniteOnboardingEmailsParams {
  customerEmail: string;
  enabled?: boolean;
}

export function useInfiniteOnboardingEmails({ customerEmail, enabled = true }: UseInfiniteOnboardingEmailsParams) {
  const normalizedEmail = customerEmail.trim().toLowerCase();

  return useQuery({
    queryKey: infiniteOnboardingEmailQueryKeys.byEmail(normalizedEmail),
    queryFn: async () => {
      const response = await searchSentEmails({
        email: normalizedEmail,
        limit: 1000,
        offset: 0,
      });

      return response.result.filter((email) => email.notification_type === INFINITE_ONBOARDING_NOTIFICATION_TYPE);
    },
    enabled: enabled && !!normalizedEmail,
    staleTime: 30_000,
  });
}
